
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__list","viewBox":"0 0 16 16","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 2H11a1.5 1.5 0 011.5 1.5v9A1.5 1.5 0 0111 14H4.5A1.5 1.5 0 013 12.5v-9A1.5 1.5 0 014.5 2zm-.25 4a.25.25 0 00-.25.25v6a.76.76 0 00.75.75h6a.76.76 0 00.75-.75v-6a.25.25 0 00-.25-.25zm1.25 5H7a.5.5 0 010 1H5.5a.5.5 0 010-1zm0-2h3a.5.5 0 010 1h-3a.5.5 0 010-1zm0-2h2a.5.5 0 010 1h-2a.5.5 0 010-1z"}})])
          )
        }
      }
    